import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'


export default class UnauthorizedException extends BaseErrorHandler {
    protected AlertType: AlertTypeEnum = AlertTypeEnum.ERROR;
    protected Code: string = "Unauthorized";

    customizeAction(): void {
        // router.push({
        //     name: "AccessDenied"
        // })
    }
}
